import { contactInfo } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-9">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">联系我们</h2>
          <p className="mt-2 text-sm text-foreground-500">{contactInfo.desc}</p>
        </div>
        <div className="max-w-lg mx-auto bg-background-100 rounded-lg border border-background-200/70 p-6 md:p-10">
          <div className="flex flex-col sm:flex-row gap-6">
            <div className="flex-1 flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 shrink-0">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <div>
                <p className="text-sm font-medium text-foreground-700">电子邮箱</p>
                <a href={`mailto:${contactInfo.email}`} className="text-sm text-primary-500 hover:text-primary-600 transition-colors">
                  {contactInfo.email}
                </a>
              </div>
            </div>
            <div className="flex-1 flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 shrink-0">
                <i className="ri-wechat-line text-lg"></i>
              </div>
              <div>
                <p className="text-sm font-medium text-foreground-700">微信公众号</p>
                <p className="text-sm text-foreground-600">{contactInfo.wechat}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}